// Import all MP3 sound files
import deviceConnected from './mp3/device_connected.mp3';
import deviceDisconnected from './mp3/device_disconnected.mp3';
import engineStart from './mp3/engine_start.mp3';
import engineStop from './mp3/engine_stop.mp3';
import fuelTheft from './mp3/fuel_theft.mp3';
import geofenceEntry from './mp3/geofence_entry.mp3';
import geofenceExit from './mp3/geofence_exit.mp3';
import gpsLost from './mp3/gps_lost.mp3';
import gpsRestored from './mp3/gps_restored.mp3';
import harshAcceleration from './mp3/harsh_acceleration.mp3';
import harshBraking from './mp3/harsh_braking.mp3';
import idleTooLong from './mp3/idle_too_long.mp3';
import lowBattery from './mp3/low_battery.mp3';
import overspeed from './mp3/overspeed.mp3';
import powerOff from './mp3/power_off.mp3';
import powerOn from './mp3/power_on.mp3';
import sosAlarm from './mp3/sos_alarm.mp3';
import towingAlarm from './mp3/towing_alarm.mp3';
import fleetNotification from './fleet_notification/notification.mp3';
import fleetInfoPing from './fleet_notification/info_ping.mp3';
import fleetWarningDouble from './fleet_notification/warning_double.mp3';
import fleetCriticalTriple from './fleet_notification/critical_triple.mp3';
import fleetEngineStart from './fleet_notification/engine_start.mp3';
import fleetEngineStop from './fleet_notification/engine_stop.mp3';
import fleetGeofenceEnter from './fleet_notification/geofence_enter.mp3';
import fleetGeofenceExit from './fleet_notification/geofence_exit.mp3';
import fleetGpsLost from './fleet_notification/gps_lost.mp3';
import fleetGpsRestored from './fleet_notification/gps_restored.mp3';
import fleetOverspeedAlert from './fleet_notification/overspeed_alert.mp3';
import fleetPowerCut from './fleet_notification/power_cut.mp3';
import fleetPowerRestored from './fleet_notification/power_restored.mp3';
import fleetSosEmergency from './fleet_notification/sos_emergency.mp3';
import fleetTamperAlert from './fleet_notification/tamper_alert.mp3';

// Export individual sounds
export {
  deviceConnected,
  deviceDisconnected,
  engineStart,
  engineStop,
  fuelTheft,
  geofenceEntry,
  geofenceExit,
  gpsLost,
  gpsRestored,
  harshAcceleration,
  harshBraking,
  idleTooLong,
  lowBattery,
  overspeed,
  powerOff,
  powerOn,
  sosAlarm,
  towingAlarm,
  fleetNotification,
  fleetInfoPing,
  fleetWarningDouble,
  fleetCriticalTriple,
  fleetEngineStart,
  fleetEngineStop,
  fleetGeofenceEnter,
  fleetGeofenceExit,
  fleetGpsLost,
  fleetGpsRestored,
  fleetOverspeedAlert,
  fleetPowerCut,
  fleetPowerRestored,
  fleetSosEmergency,
  fleetTamperAlert,
};

// Export all sounds in one object for easy access
export const allSounds = {
  deviceConnected,
  deviceDisconnected,
  engineStart,
  engineStop,
  fuelTheft,
  geofenceEntry,
  geofenceExit,
  gpsLost,
  gpsRestored,
  harshAcceleration,
  harshBraking,
  idleTooLong,
  lowBattery,
  overspeed,
  powerOff,
  powerOn,
  sosAlarm,
  towingAlarm,
  fleetNotification,
  fleetInfoPing,
  fleetWarningDouble,
  fleetCriticalTriple,
  fleetEngineStart,
  fleetEngineStop,
  fleetGeofenceEnter,
  fleetGeofenceExit,
  fleetGpsLost,
  fleetGpsRestored,
  fleetOverspeedAlert,
  fleetPowerCut,
  fleetPowerRestored,
  fleetSosEmergency,
  fleetTamperAlert,
};

// Export sounds by category for better organization
export const alertSounds = {
  sos: sosAlarm,
  towing: towingAlarm,
  overspeed,
  fuelTheft,
  lowBattery,
};

export const engineSounds = {
  start: engineStart,
  stop: engineStop,
};

export const geofenceSounds = {
  entry: geofenceEntry,
  exit: geofenceExit,
};

export const gpsSounds = {
  lost: gpsLost,
  restored: gpsRestored,
};

export const deviceSounds = {
  connected: deviceConnected,
  disconnected: deviceDisconnected,
};

export const powerSounds = {
  on: powerOn,
  off: powerOff,
};

export const drivingSounds = {
  harshAcceleration,
  harshBraking,
  idleTooLong,
};

// Helper function to play a sound
export const playSound = (soundFile, volume = 1.0) => {
  const audio = new Audio(soundFile);
  audio.volume = volume;
  audio.play().catch(error => {
    console.error('Error playing sound:', error);
  });
  return audio;
};

// Helper function to preload all sounds
export const preloadAllSounds = () => {
  Object.values(allSounds).forEach(sound => {
    const audio = new Audio(sound);
    audio.preload = 'auto';
  });
};
